import { useFetchReportCategoriesQuery } from "../../../../services/clientreports";

const useReportCategories = () => {
    const { data, error, isError, isFetching, isLoading, refetch } = useFetchReportCategoriesQuery({ });
    const { results } = data || { results: [] };

    const reload = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        refetch({ });
    };

    return {
        data: results,
        error,
        isError,
        isLoading: isFetching || isLoading,
        reload
    };
};

export default useReportCategories;